<div class="wrapper">

  <label
    class="dropzone"
    [class.dropzone--active]="dragActive()"
    [class.dropzone--has-file]="!!selectedFile()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
  >
    <input type="file" class="dropzone__input" (change)="onFileSelected($event)" [accept]="validExtensions()"/>

    <svg class="dropzone__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 3v12m0-12 4 4m-4-4-4 4M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"
            stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    @if (selectedFile(); as file) {
      <span class="dropzone__filename">{{ file.name }}</span>
      <span class="dropzone__hint">Click or drop to replace</span>
    } @else {
      <span class="dropzone__label">Drag and drop a file, or click to browse</span>
    }
  </label>

  <button pButton severity="secondary" (click)="upload()" [disabled]="!selectedFile() || uploading()">
    {{ uploading() ? 'Uploading…' : 'Upload' }}
  </button>

  @if (error()) {
    <div class="error"><strong>Error:</strong> {{ error() }}</div>
  }

</div>
